/* flow-theme.js — FLOW Shopify theme interactions */

/* ---- Reveal on scroll ---- */
(function () {
  const io = new IntersectionObserver(
    entries =>
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      }),
    { threshold: 0.12, rootMargin: '0px 0px -7% 0px' }
  );
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

/* ---- Marquee duplication ---- */
document.querySelectorAll('.flow-marquee__track').forEach(track => {
  track.innerHTML += track.innerHTML;
});

/* ---- Toast ---- */
let _toastTimer;
window.flowToast = function (msg) {
  let t = document.getElementById('flow-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'flow-toast';
    t.className = 'flow-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(_toastTimer);
  _toastTimer = setTimeout(() => t.classList.remove('show'), 2400);
};

/* ---- Mobile menu ---- */
(function () {
  const burger = document.getElementById('flow-burger');
  const nav    = document.getElementById('flow-mobile-nav');
  if (!burger || !nav) return;

  burger.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  nav.querySelectorAll('a').forEach(link =>
    link.addEventListener('click', () => {
      nav.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    })
  );
})();

/* ---- Workshop film player ---- */
(function () {
  const stage = document.getElementById('flowFilmStage');
  if (!stage) return;
  const poster = stage.querySelector('.poster');

  function loadChapter(ch) {
    document.querySelectorAll('.chapter').forEach(c => c.classList.remove('active'));
    ch.classList.add('active');
    stage.classList.remove('playing');
    const v = stage.querySelector('video');
    if (v) v.remove();
    if (poster) { poster.style.display = ''; poster.src = ch.dataset.poster; }
    stage.dataset.video  = ch.dataset.video || '';
    stage.dataset.poster = ch.dataset.poster;
    const ttl = stage.querySelector('.film-meta .ttl');
    if (ttl) ttl.innerHTML = `<span>${ch.dataset.index}</span>${ch.dataset.title}`;
    const rt = stage.querySelector('.film-runtime');
    if (rt) rt.textContent = ch.dataset.runtime;
  }

  function play() {
    const src = stage.dataset.video;
    if (!src) { window.flowToast('Upload a workshop film to Theme Assets and add its URL in the section settings.'); return; }
    if (stage.querySelector('video')) return;
    const v = document.createElement('video');
    v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
    v.poster = stage.dataset.poster;
    stage.appendChild(v);
    stage.classList.add('playing');
    if (poster) poster.style.display = 'none';
    v.play().catch(() => {});
  }

  stage.addEventListener('click', e => { if (!e.target.closest('video')) play(); });
  document.querySelectorAll('.chapter').forEach(ch => {
    ch.addEventListener('click', () => {
      loadChapter(ch);
      if (!window.matchMedia('(hover:none)').matches) play();
    });
  });
})();

/* ---- Newsletter forms (footer inline form fallback) ---- */
document.querySelectorAll('.flow-inline-news').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    window.flowToast('Welcome — see you at the workshop.');
    form.reset();
  });
});
